import axios from 'axios';
import { useQuery } from '@tanstack/react-query';
import { Sponsor } from '@repo/types';
import API from '../endpoints';
import { getAccessToken } from '../utils/getAccessToken';
import { useGlobalContext } from '@slc/tools/GlobalContext';

// 30 minutes frontend cache for sponsor list query
const CACHE_TIME = 30 * 60 * 1000;

export const useSponsorsQuery = () => {
  const { apiUrl } = useGlobalContext();

  return useQuery({
    queryKey: ['sponsors', apiUrl],
    queryFn: () => fetchSponsors(apiUrl),
    staleTime: !getAccessToken() ? CACHE_TIME : undefined,
    enabled: !!apiUrl,
  });
};

const fetchSponsors = async (apiUrl: string): Promise<Sponsor[]> => {
  const accessToken = getAccessToken();
  const { data } = await axios.get<Sponsor[]>(`${apiUrl}${API.endpoints.sponsors}`, {
    headers: accessToken
      ? {
          Authorization: `Bearer ${accessToken}`,
        }
      : {},
  });
  return data;
};
